import { useOptionDescription as useDescription } from "@/components/features/items/edit/option/_shared/ui/components/description/hooks/use-description";

import { useProductOptionI18nFormModelContext } from "../../../../context";

export const useOptionI18nDescription = () => {
	const { viewModel, onSetViewModel } = useProductOptionI18nFormModelContext();
	const { description } = viewModel;

	return useDescription({ description, onSetViewModel });
};
